import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import AuthLayout from 'layout/Auth';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const ForgotPassword = Loadable(lazy(() => import('pages/auth/forgotPassword')));
const CheckMail = Loadable(lazy(() => import('pages/auth/checkMail')));
const ResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const VerifyOtp = Loadable(lazy(() => import('pages/auth/code-verification')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        { path: 'login', element: <AuthLogin /> },
        { path: 'forgot-password', element: <ForgotPassword /> },
        { path: 'check-mail', element: <CheckMail /> },
        { path: 'code-verification', element: <VerifyOtp /> },
        { path: 'reset-password', element: <ResetPassword /> }
      ]
    }
  ]
};

export default LoginRoutes;
